import escapeRegExp from 'lodash/escapeRegExp';

function alphaNumericNoSpaceValidator({ configs, input, msgs }) {
  const allowChars = configs.allow ? configs.allow.replace('&comma', ',').split(';').join('') : '';
  const disallowChars = configs.disallow ? configs.disallow.replace('&comma', ',').split(';') : [];
  const regExpString = `^[a-zA-Z0-9${escapeRegExp(allowChars).replace('-', '\\-')}]+$`;
  const rule = new RegExp(regExpString);
  const defaultError = 'Special characters are not allowed in this field.';

  for (let i = 0; i < disallowChars.length; i += 1) {
    if (input.includes(disallowChars[i])) {
      return (
        msgs.disallow.replace('%s', disallowChars.join(' ')) ||
        'The following special characters are not allowed in this field: %s'.replace(
          '%s',
          disallowChars.join(' '),
        )
      );
    }
  }

  if (!rule.test(input)) {
    if (allowChars.length > 0 && msgs.allow) {
      return msgs.allow
        ? msgs.allow.replace('%s', allowChars)
        : 'The following special characters are allowed in this field: %s'.replace(
            '%s',
            allowChars,
          );
    }

    return (msgs && msgs.msg) || defaultError;
  }

  return null;
}

export default alphaNumericNoSpaceValidator;
